<template>
  <centered-box>
    <b-card title="Sign out" class="title-center" border-variant="primary">
      <div>
        We're signing you out
        <div class='text-center' style="margin-top: 20px">
          <loading-spinner />
        </div>
      </div>
    </b-card>
  </centered-box>
</template>

<script>
import LoadingSpinner from '@/components/common/LoadingSpinner';
import CenteredBox from '@/components/common/CenteredBox';

const PortalApi = require("@brightoncromwell/portal-api");
const tokensApiInstance = new PortalApi.TokensApi();

export default {
  name: "signout-page",
  metaInfo: {
    title: "Signout"
  },
  components: {
    'loading-spinner': LoadingSpinner,
    'centered-box': CenteredBox
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    revokeTokens: function(querystring) {
      this.loading = true;
      tokensApiInstance.tokensRevokePost((error, data, response) => {
        this.loading = false;
        if (error) {
          console.error(error);
          this.$emit('onError', response)
        } else {
          localStorage.removeItem("session");
          this.$router.push("/signin")
        }
      });
    },
  },
  created() {
    this.revokeTokens();
  }
};

</script>
